<template>
  <div>
    <Head title="Ruta | Clientes" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-sky-400 hover:text-sky-600" href="/routes">Rutas</Link>
      <span class="text-sky-400 font-medium">/</span> Clientes
    </h1>
    <div class="flex items-center justify-between mb-6">  
      <search v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />    
      <button class="btn-sky" @click="showDialog">Agregar Cliente</button>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">          
          <th class="pb-4 pt-6 px-2">Ruta</th>            
          <th class="pb-4 pt-6 px-2">Descripción cliente</th>
          <!-- <th class="pb-4 pt-6 px-2">Estatus XD</th> -->
          <th class="pb-4 pt-6 px-2">Acción</th>
        </tr>
        <tr v-for="client in clients.data" :key="client.id" class="hover:bg-gray-100 focus-within:bg-gray-100"> 
          <td class="border-t">
            <Link class="flex items-center px-6 py-4">
              {{ getRouteDescription(client.id_route) }}
            </Link>
          </td><td class="border-t">
            <Link class="flex items-center px-6 py-4">
              {{ getClientDescription(client.id_client) }}
            </Link>
          </td>         
          <!-- <td class="border-t">
            <Link class="flex items-center px-6 py-4">
              {{ client.estatus }}
            </Link>
          </td> -->
          <td class="border-t">
            <button class="btn-delete"  @click="removeClient(client.id)">Remover</button>
          </td>
        </tr>
        <tr v-if="clients.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="14">No se encontraron clientes para esta ruta.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="clients.links" />
  </div>
  <div>    
    <DialogInput v-if="showDialogInput" v-model="dialogValue" label="Nombre" :title="'Agregar cliente a la ruta'" @close="closeDialog">      
      <form class="w-full max-w-sm py-2" @submit.prevent="storeClients">
        <div>
          <select-input v-model="form.client" :error="form.errors.client" class="py-2 w-full" label="Cliente">
            <option v-for="clie in clientsWithoutRoute" :key="clie.id" :value="clie.id">{{ clie.cliente }} / {{ clie.employee.first_name }} {{ clie.employee.last_name }}</option>
          </select-input>         
        </div>
        <div class="flex items-center justify-center px-8 py-4">          
          <loading-button :loading="form.processing" class="btn-sky" type="submit">Agregar</loading-button>
        </div>        
      </form>
    </DialogInput>
  </div>
</template>
  
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import DialogInput from '@/Shared/Dialog'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Search from '@/Shared/Search'
import Pagination from '@/Shared/Pagination'
import Swal from 'sweetalert2'
  
export default {
  components: {
    Head,
    Link,
    DialogInput,
    LoadingButton,
    SelectInput,
    Search,
    Pagination,
  },
  layout: Layout,
  props: {    
    clients: Array,  
    clie: Array,    
    allClients: Array,
    clientsWithoutRoute: Array,
    routeClients: Array,
    routeId: String,
    allRoute:Array,   
    codes: Object, 
    families: Object,
    categories: Object,      
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        client: '',
        id_route: this.routeId,
         //search: this.filters.search,
        // code: this.filters.code,
      }),
      dialogValue: '',
      showDialogInput: false, // Nuevo dato para controlar la visibilidad del diálogo        
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        const url = `/routes/${this.routeId}/clients`
        this.$inertia.get(url, pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    showDialog() {
      this.showDialogInput = true // Mostrar el diálogo al hacer clic en el botón
    },
    closeDialog() {
      this.showDialogInput = false // Cerrar el diálogo cuando se emite el evento 'close'
    },
    storeClients() {
      // Utilizando async/await para esperar la respuesta del envío de datos
      (async () => {
        try {
          await this.$inertia.post('/route_clients', this.form)
          // Si la respuesta es exitosa, cierra el diálogo
          this.closeDialog()
          // Puedes agregar aquí cualquier lógica adicional después de enviar los datos
        } catch (error) {
          console.error('Error al enviar datos:', error)
          // Puedes manejar el error aquí si es necesario
        }
      })()
    },
    getRouteDescription(number) {
      const route = this.allRoute.find(cat => cat.id === number)
      return route ? route.descripcion : 'Ruta no disponible'
    },   
    getClientDescription(number){
      const client = this.allClients.find(cat=> cat.id=== number)
      return client ? client.cliente: 'Cliente no disponible'
    },
    removeClient(number) {
      // let id_route_client = this.routeClients.find(cat => cat.id_client_route == number)
      // console.log("id_ del cliente ruta: "+ id_route_client.id)
      Swal.fire({
        title: 'Remover Cliente',
        text: '¿Deseas quitar el cliente de la ruta?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Remover!',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(`/route_clients/${number}`)
        }
      })
    },
  },
}   
</script>